var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-order area"
  }, [_c("div", {
    staticClass: "product-order__title puhui-M"
  }, [_vm._v("闪电下单，擒牛快人一步")]), _c("div", {
    staticClass: "product-order__info"
  }, [_vm._v(" 与同花顺行情端实时联动，交易随心所欲，毫秒级交易延迟，交易速度快人一步，成功抢筹 ")]), _c("div", {
    staticClass: "product-order__pic"
  }, [_c("div", {
    staticClass: "btns"
  }, [_c("span", [_vm._v("行情端实时联动")]), _c("span", [_vm._v("行情端实时联动")]), _c("span", [_vm._v("行情端实时联动")])]), _c("img", {
    attrs: {
      src: require("@/assets/images/service/institutional-trading/pbtrade_product_3.png"),
      alt: ""
    }
  })])]);
}];
render._withStripped = true;
export { render, staticRenderFns };